import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const merchantRoutes = []
if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_INCLUDE_DEMOS) {
  const vueBookRoutes = require('./vueBookRoutes').default
  vueBookRoutes.forEach(route => merchantRoutes.push(route))
}

const ifNotAuthenticated = (to, from, next) => {
  if(!localStorage.getItem('admin_token')) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if(localStorage.getItem('admin_token')) {
    next()
    return
  }
  next('/giris')
}

export default new Router({
  mode: 'history',
  routes: [
    ...merchantRoutes,
    {
      path: '*',
      redirect: { path: '/pano' },
      beforeEnter: ifAuthenticated
    },
    {
      path: '/',
      redirect: { path: '/pano' },
      beforeEnter: ifAuthenticated
    },
    {
      path: '/giris',
      component: AuthLayout,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/404',
      component: () => import('../components/pages/404-pages/VaPageNotFoundSimple.vue')
    },
    {
      name: 'admin',
      path: '/',
      component: AppLayout,
      beforeEnter: ifAuthenticated,
      children: [
        {
          name: 'dashboard',
          path: 'pano',
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
          beforeEnter: ifAuthenticated
        },
        {
          name: 'rents',
          path: 'rezervasyon',
          component: EmptyParentComponent,
          children: [
            {
              name: 'my-rents',
              path: 'listesi',
              component: () => import('../components/rents/List.vue'),
              beforeEnter: ifAuthenticated
            },
            {
              name: 'view-rent',
              path: ':id',
              component: () => import('../components/rents/Detail'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
              },
              beforeEnter: ifAuthenticated
            },
          ],
        },
        {
          name: 'users',
          path: 'uye',
          component: EmptyParentComponent,
          children: [
            {
              name: 'my-users',
              path: 'listesi',
              component: () => import('../components/users/List.vue'),
              beforeEnter: ifAuthenticated
            }
          ]
        },
        {
          name: 'campaigns',
          path: 'kampanya',
          component: EmptyParentComponent,
          children: [
            {
              name: 'my-campaigns',
              path: 'listesi',
              component: () => import('../components/campaigns/List.vue'),
              beforeEnter: ifAuthenticated
            },
            {
              name: 'add-campaign',
              path: 'ekleme',
              component: () => import('../components/campaigns/Form.vue'),
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'view-campaign',
              path: ':id',
              component: () => import('../components/campaigns/Detail.vue'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'edit-campaign',
              path: ':id/duzenleme',
              component: () => import('../components/campaigns/Form'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'translate-campaign',
              path: ':id/ceviri',
              component: () => import('../components/campaigns/Translation'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
              },
              beforeEnter: ifAuthenticated
            },
          ],
        },
        {
          name: 'vehicles',
          path: 'arac',
          component: EmptyParentComponent,
          children: [
            {
              name: 'my-vehicles',
              path: 'listesi',
              component: () => import('../components/vehicles/List.vue'),
              beforeEnter: ifAuthenticated
            },
            {
              name: 'add-vehicle',
              path: 'ekleme',
              component: () => import('../components/vehicles/Form.vue'),
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'view-vehicle',
              path: ':id',
              component: () => import('../components/vehicles/Detail'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'edit-vehicle',
              path: ':id/duzenleme',
              component: () => import('../components/vehicles/Form'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
              },
              beforeEnter: ifAuthenticated
            },
          ],
        },
        {
          name: 'segments',
          path: 'segment',
          component: EmptyParentComponent,
          children: [
            {
              name: 'my-vehicle-segments',
              path: 'listesi',
              component: () => import('../components/vehicles/segments/List.vue'),
              beforeEnter: ifAuthenticated
            },
            {
              name: 'add-vehicle-segment',
              path: 'ekleme',
              component: () => import('../components/vehicles/segments/Form.vue'),
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'edit-vehicle-segment',
              path: ':id/duzenleme',
              component: () => import('../components/vehicles/segments/Form.vue'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'translate-vehicle-segment',
              path: ':id/ceviri',
              component: () => import('../components/vehicles/segments/Translation.vue'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
          ],
        },
        {
          name: 'vehicleExtras',
          path: 'ekstra',
          component: EmptyParentComponent,
          children: [
            {
              name: 'my-vehicle-extras',
              path: 'listesi',
              component: () => import('../components/vehicles/extras/List.vue'),
              beforeEnter: ifAuthenticated
            },
            {
              name: 'edit-vehicle-extra',
              path: ':id/duzenleme',
              component: () => import('../components/vehicles/extras/Form.vue'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'translate-vehicle-extra',
              path: ':id/ceviri',
              component: () => import('../components/vehicles/extras/Translation.vue'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            }
          ]
        },
        {
          name: 'regions',
          path: 'bolge',
          component: EmptyParentComponent,
          children: [
            {
              name: 'my-regions',
              path: 'listesi',
              component: () => import('../components/regions/List.vue'),
              beforeEnter: ifAuthenticated
            },
            {
              name: 'add-region',
              path: 'ekleme',
              component: () => import('../components/regions/Form.vue'),
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'edit-region',
              path: ':id/duzenleme',
              component: () => import('../components/regions/Form.vue'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
            {
              name: 'translate-region',
              path: ':id/ceviri',
              component: () => import('../components/regions/Translation.vue'),
              props: true,
              meta: {
                // wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
              beforeEnter: ifAuthenticated
            },
          ],
        },
        {
          name: 'settings',
          path: 'ayar',
          component: EmptyParentComponent,
          children: [
            {
              name: 'my-settings',
              path: 'listesi',
              component: () => import('../components/settings/Form.vue'),
              beforeEnter: ifAuthenticated
            }
          ]
        },
      ],
    },
  ],
})
